<template>
  <ModalComp
    :is-visible="isVisible"
    :title="bloque ? 'Bloquer la commande' : 'Débloquer la commande'"
    size="sm"
    hide-footer
    @update:is-visible="emit('update:isVisible', $event)"
  >
    <template #body>
      <div class="space-y-4 text-sm text-gray-800">
        <p>
          Choisissez le périmètre à {{ bloque ? 'bloquer' : 'débloquer' }}.
          {{ bloque
            ? 'Le statut précédent sera conservé séparément pour chaque commande.'
            : 'Chaque commande bloquée retrouvera son statut précédent.' }}
        </p>

        <div class="grid gap-3">
          <button
            type="button"
            class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-left transition-colors hover:bg-red-100 disabled:cursor-not-allowed disabled:opacity-50"
            :disabled="loading"
            @click="selectScope('commande')"
          >
            <span class="block font-semibold text-red-800">
              Cette commande uniquement
            </span>
            <span class="mt-1 block text-xs text-red-700">
              Seule la commande #{{ idCommande }} sera modifiée.
            </span>
          </button>

          <button
            v-if="groupCount !== 1"
            type="button"
            class="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-left transition-colors hover:bg-amber-100 disabled:cursor-not-allowed disabled:opacity-50"
            :disabled="loading"
            @click="selectScope('groupe')"
          >
            <span class="block font-semibold text-amber-900">
              Toutes les commandes du groupe
            </span>
            <span class="mt-1 block text-xs text-amber-800">
              <template v-if="groupCount && groupCount > 1">
                Les {{ groupCount }} commandes du groupe seront modifiées.
              </template>
              <template v-else>
                Chaque commande rattachée au même groupe sera modifiée.
              </template>
            </span>
          </button>
        </div>

        <div class="flex justify-end">
          <button
            type="button"
            class="rounded-lg border border-gray-300 px-4 py-2 text-sm hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
            :disabled="loading"
            @click="emit('update:isVisible', false)"
          >
            Annuler
          </button>
        </div>
      </div>
    </template>
  </ModalComp>
</template>

<script setup lang="ts">
import { ModalComp } from '@/components'

export type OrderBlockingScope = 'commande' | 'groupe'

defineProps<{
  isVisible: boolean
  bloque: boolean
  idCommande: number
  groupCount?: number | null
  loading?: boolean
}>()

const emit = defineEmits<{
  'update:isVisible': [value: boolean]
  select: [scope: OrderBlockingScope]
}>()

function selectScope(scope: OrderBlockingScope) {
  emit('select', scope)
}
</script>
